<dx-data-grid
    #grid
    height="100%"
    [dataSource]="lignes"
    keyExpr="id"
    noDataText="Pas de données"
    showBorders="true"
    showRowLines="true"
    allowColumnResizing="true"
    rowAlternationEnabled="true"
    columnResizingMode="widget"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    (onOptionChanged)="onGridOptionChanged($event)">

    <dxo-selection
            selectAllMode="allPages"
            showCheckBoxesMode="always"
            mode="multiple">
    </dxo-selection>

    <dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-pager
            [showPageSizeSelector]="true"
            [showNavigationButtons]="false"
            [allowedPageSizes]="[20, 50, 100, 200]"
            [visible]="true"
            [showInfo]="true"
            infoText="{2} ligne(s) de paramétrage">
    </dxo-pager>

    <dxi-column
            caption="Point de facturation"
            dataField="pointFacturationLibelle">
    </dxi-column>
    <dxi-column
            caption="Point de livraison"
            dataField="pointLivraisonLibelle">
    </dxi-column>
    <dxi-column
            caption="Offre alimentaire"
            dataField="offreAlimentaireLibelle">
    </dxi-column>
    <dxi-column
            caption="Prestation"
            dataField="prestationLibelle">
    </dxi-column>
    <dxi-column
            caption="Repas"
            dataField="repasLibelle">
    </dxi-column>
    <dxi-column
            caption="Régime"
            dataField="regimeLibelle">
    </dxi-column>
    <dxi-column
            caption="Élément facturable"
            dataField="elementFacturableLibelle">
    </dxi-column>
    <dxi-column
            caption="Taxe EF"
            dataField="taxeEFLibelle">
    </dxi-column>
    <dxi-column
      caption="Prix de vente HT"
      dataField="prixVenteHT"
      alignment="center"
      cellTemplate="prixTemplate"
      [filterOperations]="['=']"
      [(filterValue)]="selectedPeriode"
      [calculateFilterExpression]="calculateFilterExpression">
      <dxo-header-filter
        [visible]="true"
        [dataSource]="periodes"
        [allowSearch]="false">
      </dxo-header-filter>
    </dxi-column>
    <dxi-column
            caption="Frais fixe"
            dataField="fraisFixeLibelle">
    </dxi-column>
    <dxi-column
            caption="Taxe FF"
            dataField="taxeFFLibelle">
    </dxi-column>
    <dxi-column
      caption="Frais fixe HT"
      dataField="fraisFixeHT"
      alignment="center"
      cellTemplate="fraisFixeHTTemplate"
      [filterOperations]="['=']"
      [(filterValue)]="selectedPeriode"
      [calculateFilterExpression]="calculateFilterExpression">
      <dxo-header-filter
        [visible]="true"
        [dataSource]="periodes"
        [allowSearch]="false">
      </dxo-header-filter>
    </dxi-column>

  <div *dxTemplate="let cell of 'prixTemplate'" class="prix-container">
    <ng-container
      *ngFor="let periodeParametragefacturation of cell?.row?.data?.periodeParametrageFacturationList">
      <div>
        <span>{{ utilsSvc.isIdInit(periodeParametragefacturation?.id) ? '' : '+'}}</span>
        <span>{{ periodeParametragefacturation?.periodeToDelete ? '-' : ''}}</span>
        <label class="badge badge-secondary">
          {{ utilsSvc.formatDate(periodeParametragefacturation?.dateDebut) }}
        </label>
        <span class="periode-prix-montant"> {{ periodeParametragefacturation?.prixVenteHT ? periodeParametragefacturation.prixVenteHT.toFixed(3) : 0 }} €</span>
      </div>
    </ng-container>
  </div>

  <div *dxTemplate="let cell of 'fraisFixeHTTemplate'" class="prix-container">
    <ng-container
      *ngFor="let periode of cell?.row?.data?.periodeParametrageFacturationFraisFixeList">
      <div>
        <span>{{ utilsSvc.isIdInit(periode?.id) ? '' : '+'}}</span>
        <span>{{ periode?.periodeToDelete ? '-' : ''}}</span>
        <label class="badge badge-secondary">
          {{ utilsSvc.formatDate(periode?.dateDebut) }}
        </label>
        <span class="periode-prix-montant"> {{ periode?.fraisFixeHT ? periode.fraisFixeHT.toFixed(3) : 0 }} €</span>
      </div>
    </ng-container>
  </div>

  <div *dxTemplate="let cell of 'beforeTemplate'">
      <ng-content select="[data-position='left']"></ng-content>
    </div>

    <div *dxTemplate="let cell of 'afterTemplate'">
      <ng-content select="[data-position='right']"></ng-content>
    </div>

    <ng-content></ng-content>

</dx-data-grid>

